import { render, staticRenderFns } from "./StoreCredits.vue?vue&type=template&id=7bbe0918"
import script from "./StoreCredits.vue?vue&type=script&lang=js"
export * from "./StoreCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports